import { adminClient as apolloClient } from '@/store/apollo';

import CustomerGroupsGql from '@/extensions/shop/store/graphql/queries/CustomerGroups.gql';

export default {
    fetchList: (shopId = null) =>
        new Promise((resolve, reject) => {
            let variables = {};
            if (shopId) variables.shop = parseInt(shopId);

            apolloClient
                .query({
                    query: CustomerGroupsGql,
                    variables
                })
                .then(({ data }) => resolve(data.CO_CustomerGroups))
                .catch(err => reject(err));
        })
};
